<template lang="html">
  <div>
    <md-toolbar>
      <md-layout>
        adasda

      </md-layout>
      
    </md-toolbar>

  </div>
</template>
<script type="text/javascript">
  import { toMoney } from '../../common/functions/helpers';
  import Email from '../../common/functions/smtp'

  export default {
    props: {
      // nombreUsuario: String,
    },
    data() {
      return {
        resourceCliente: this.$api.cliente(this.$resource),
        empresa: {},
      };
    },
    computed: {
    },
    components: {
    },
    methods: {
      getEmpresa() {
        this.resourceCliente.empresa()
          .then((response) => {
            empresa = response.body.data;
          })
          .catch((err) => {
            this.$error(this, err);
          });
      },
      goToCatalogo() {
        this.$router.push({ name: 'inicio' });
      },
    },
    mounted() {
      // this.logInAuth();
      // this.getParametros();
      if(localStorage.getItem('empresa')) {
        this.empresa = JSON.parse(localStorage.getItem('empresa'));  
      } else {
        this.getEmpresa();
      }
    },
  };
</script>
<style src="./footer.scss" lang="scss"></style>
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/shared-components/footer/footer.vue